module.exports = __webpack_public_path__ + "img/545.2e0ea60d.png";